import type { CSSProperties } from 'react';

export function Skeleton({
  w,
  h = 14,
  r = 'var(--r-xs)',
  style,
}: {
  w?: number | string;
  h?: number;
  r?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      aria-hidden
      style={{
        width: w ?? '100%',
        height: h,
        borderRadius: r,
        background: 'linear-gradient(90deg, var(--bg-2) 0%, var(--panel-2) 40%, var(--bg-2) 80%)',
        backgroundSize: '260px 100%',
        animation: 'shimmer 1.4s linear infinite',
        ...style,
      }}
    />
  );
}

// geometria identica al contenuto reale (§8): la riga della home è alta 76
export function SkeletonRow() {
  return (
    <div
      style={{
        height: 76,
        background: 'var(--panel)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)',
        padding: '0 16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 8,
      }}
    >
      <Skeleton w="52%" h={16} />
      <Skeleton w="74%" h={12} />
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
      <Skeleton w="70%" h={14} />
      <Skeleton w="40%" h={34} />
      <Skeleton w="60%" h={12} />
    </div>
  );
}
